// Uses window.tsapp
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

var tr = require('ts-translate-js').default.boundTR;
var moment = require('moment');

export const FormTextGroup = createClass({
    displayName: "FormTextGroup",

    focus: function() {
        this.refs.inputToFocus.focus();
    },
    render: function() {
        return (
            <FormGroup id={this.props.id} label={this.props.label} help={this.props.help}>
                <FormTextCtl {...this.props} ref="inputToFocus"></FormTextCtl>
            </FormGroup>
        );
    }
});

// Use this as a FormGroup. It's the way we do checkboxes using bootstrap
// It also converts the checked property to a boolean in the value of the target.
export const FormCheckbox = createClass({
    displayName: "FormCheckbox",

    focus: function() {
        this.refs.inputToFocus.focus();
    },
    handleChange: function(e){
        this.props.onChange({
            target: {
                name: e.target.name,
                value: e.target.checked
            }
        });
    },
    render: function() {
        return (
            <div className="checkbox">
                <label>
                    <input {...this.props} onChange={this.handleChange} type="checkbox"/>
                    {this.props.label}
                </label>
            </div>
        );
    }
});



export const FormCardExpirationGroup = createClass({
    displayName: "FormCardExpirationGroup",

    render: function() {
        return (
            <FormGroup id={this.props.id} label={this.props.label} help={this.props.help}>
                <MonthSelector id={this.props.id + '_month'} bootstrap="col-xs-4" />
                <YearSelector id={this.props.id + '_year'} bootstrap="col-xs-4" />
            </FormGroup>
        );
    }
});

export const FormGroup = createClass({
    displayName: "FormGroup",

    render: function() {
        var helpCtl;
        if(this.props.help !== undefined && this.props.help !== '')
            helpCtl = <span className="help-block">{this.props.help}</span>;

        return (
            <div className="form-group row">
                <div className="col-xs-12"><label htmlFor={this.props.id}>{this.props.label}</label></div>
                {this.props.children}
                <div className="col-xs-12">{helpCtl}</div>
            </div>
        );
    }
});

export const FormNumericTextCtl = createClass({
    displayName: "FormNumericTextCtl",

    getDefaultProps: function() {
        return { bootstrap: 'col-xs-12' };
    },
    render: function() {
        return (
            <div className={this.props.bootstrap}>
                <input id={this.props.id} name={this.props.name} className="form-control" placeholder={this.props.placeHolder} type="text"/>
            </div>
        );
    }
});

export const FormTextCtl = createClass({
    displayName: "FormTextCtl",

    getDefaultProps: function() {
        return { bootstrap: 'col-xs-12' };
    },
    focus: function() {
        this.refs.inputToFocus.focus();
    },
    render: function() {
        return (
            <div className={this.props.bootstrap}>
                <input id={this.props.id} name={this.props.name} onChange={this.props.onChange} value={this.props.value}  ref="inputToFocus" className="form-control" placeholder={this.props.placeHolder} type="text"/>
            </div>
        );
    }
});


export class MonthSelector extends Component {
    constructor(props) {
        super(props);

        this.month = [];
        this.defaultItem = null;
        this.items = [];
    }

    render() {
        // Statically create the months
        this.month = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

        this.defaultItem = <option value="0">{tr('month')}</option>;
        this.items = this.month.map(function(m) {
            return <option value={m} key={m}>{m}</option>;
        });
        return (
            <div className={this.props.bootstrap}>
                <select {...this.props} className="form-control">
                    {this.defaultItem}
                    {this.items}
                </select>
            </div>
        );
    }
};

MonthSelector.efaultProps = {
    bootstrap: 'col-xs-12'
}

export class YearSelector extends Component {
    constructor(props) {
        super(props);

        this.defaultItem = null;
        this.items = [];
    }

    render() {
        var years = [];
        var startYear = moment().year();
        for(var i = 0; i < 8; i++)
            years.push(startYear + i);

            this.defaultItem = <option value="0">{tr('year')}</option>;
        // Statically create the months
        this.items = years.map(function(m) {
            return <option value={m} key={m}>{m}</option>;
        });
        return (
            <div className={this.props.bootstrap}>
                <select {...this.props} className="form-control">
                    {this.defaultItem}
                    {this.items}
                </select>
            </div>
        );
    }
};

YearSelector.defaultProps = {
    bootstrap: 'col-xs-12' 
}
